import { CAMPAIGN_TYPE } from "../BulkCampaignCreate";

import InputComponent from "V2.0/components/InputComponent";

export default FromIdentifier;

export interface FromIdentifierProps {
  campaignType: (typeof CAMPAIGN_TYPE)[keyof typeof CAMPAIGN_TYPE];
  identifierOptions: Array<{ id: number; value: string; label: string }>;
  fromIdentifier: string;
  onChange: (e: { target: { value: string } }) => void;
}

function FromIdentifier(props: FromIdentifierProps) {
  const { campaignType, identifierOptions, fromIdentifier, onChange } = props;

  const label =
    campaignType === CAMPAIGN_TYPE.EMAIL ? "From Email *" : "From Number *";

  return (
    <InputComponent
      type="select"
      label={label}
      value={fromIdentifier}
      options={identifierOptions}
      onChange={onChange}
    />
  );
}
